import API from 'services/api.js';
import { URL_GET_SESSION_DATA } from 'services/urls.js';

export type WeightPeriods = {
	[period: string]: number | null;
};
export type EidWeightSummary = {
	eid: string;
	visId: string;
	weight: WeightPeriods;
	n: number | null;
	latest: string | null;
	days: number;
	adg: number | null;
};

export const actionFetchSessionAvg = (
	sessionId: number,
	timebase: string,
	showMessage: (msg: string) => void,
	setLoading: (l: boolean) => void
): Promise<EidWeightSummary[]> => {
	const params = {
		params: {
			sessionId: sessionId,
			timebase: timebase,
		},
	};
	return API.get(URL_GET_SESSION_DATA, params)
		.then((response) => {
			console.log('response actionFetchSessionAvg()', response);
			return response.data;
		})
		.catch((error) => {
			showMessage('Err fetching session average data: ' + error);
			return [];
		})
		.then((resp) => {
			setLoading(false);
			return resp;
		});
};
